<button
    mat-icon-button
    class="st-app-selector-menu"
    [matTooltip]="languageSettings().PSTWebSideBarTitleLabel"
    (click)="toggleSideBar.emit()">
    <mat-icon
        fontSet="material-symbols-outlined"
        class="st-app-selector-icon">
        menu
    </mat-icon>
</button>
@for (navigation of storytellingNavigation(); track navigation?.ID) {
    @switch (navigation?.Product?.toUpperCase()?.trim()) {
        @case ('EXTERNAL') {
            @if (!isLessThanSmall()) {
                <button
                    mat-icon-button
                    class="st-app-selector-app-button__external"
                    [matTooltip]="getSuiteNavLabel(navigation)"
                    [style.background-image]="`url(${navigation?.Icon})`"
                    (click)="openInNewTab(navigation?.ExternalURL)"></button>
            }
        }
        @case ('EMBEDDED') {
            @if (!isLessThanSmall()) {
                <div
                    class="app-item mtop20 hand"
                    [routerLink]="['/PST', 'embedded', navigation?.ID]">
                    <span
                        class="app-item-icon fs22"
                        [style.background-image]="`url(${navigation?.Icon})`"></span>
                    <mat-icon
                        fontSet="material-symbols-outlined"
                        class="st-app-selector-icon">
                        {{ storytellingIconsMap[navigation?.Product?.toLowerCase() ?? ''] }}
                    </mat-icon>
                    <span class="fs10">{{ navigation.Name }}</span>
                </div>
            }
        }
        @default {
            @if (isProductVisible(navigation)) {
                <button
                    mat-icon-button
                    routerLinkActive="st-app-selector-app-button--selected"
                    class="st-app-selector-app-button"
                    [routerLink]="['/PST', navigation?.Product]"
                    [matTooltip]="getSuiteNavLabel(navigation)"
                    [value]="storytellingIconsMap">
                    <mat-icon
                        fontSet="material-symbols-outlined"
                        class="st-app-selector-icon">
                        {{ storytellingIconsMap[navigation?.Product?.toLowerCase() ?? ''] }}
                    </mat-icon>
                </button>
            }
        }
    }
}
<button
    mat-icon-button
    class="st-app-selector-wastebin"
    routerLinkActive="st-app-selector-app-button--selected"
    [matTooltip]="languageSettings().PSTWebWastebinTitleLabel"
    [routerLink]="['/PST', 'wastebin', 'system', 'wastebin', NavigationItemTypes.SYSTEM_WASTEBIN_GUID]">
    <mat-icon
        fontSet="material-symbols-outlined"
        class="st-app-selector-icon">
        history
    </mat-icon>
</button>
<button
    mat-icon-button
    class="st-app-selector-templates"
    routerLinkActive="st-app-selector-app-button--selected"
    [matTooltip]="languageSettings().PSTWebManageTemplatesTitle"
    [routerLink]="['/PST', 'templates', 'system', 'templates', NavigationItemTypes.SYSTEM_TEMPLATES_GUID]">
    <mat-icon
        fontSet="material-symbols-outlined"
        class="st-app-selector-icon">
        backup_table
    </mat-icon>
</button>
